import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'

import { ButtonCustom } from './styles'

const OperatorsPageHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={() => navigate({ pathname: routes.importOperators.path, search: `is_insert=true` })}>
        {t('components.pages.employees.list.buttonAction.importAdd')}
      </Menu.Item>
      <Menu.Item key="2" onClick={() => navigate({ pathname: routes.importOperators.path, search: `is_insert=false` })}>
        {t('components.pages.employees.list.buttonAction.importOverwrite')}
      </Menu.Item>
    </Menu>
  )

  return (
    <PageHeader
      ghost={false}
      title={t('components.pages.detergents.list.pageHeader.title')}
      extra={[
        <>
          <Dropdown.Button
            key="action"
            type="primary"
            icon={<DownOutlined />}
            overlay={menu}
            onClick={() => navigate(routes.createOperator.path)}
          >
            {t('components.pages.employees.list.pageHeader.new')}
          </Dropdown.Button>
          <ButtonCustom loading={false}>{t('components.pages.employees.list.buttonAction.export')}</ButtonCustom>
        </>,
      ]}
    />
  )
}

OperatorsPageHeader.displayName = 'OperatorsPageHeader'
export default OperatorsPageHeader
